export const formatDate = (iso: string | number | Date) => {
  const date = new Date(iso)
  const yyyy = new String(date.getFullYear())
  const mm = new String(date.getMonth() + 1).padStart(2, '0')
  const dd = new String(date.getDate()).padStart(2, '0')
  return `${yyyy}.${mm}.${dd}`
}
